import { useQueryClient } from "@tanstack/react-query";
import { useLocation } from "react-router";
import { useAuthentication } from "../components/AuthenticationProvider";

export const ToastID = {
	sessionExpired: "sessionExpired",
} as const;

export type ToastID = (typeof ToastID)[keyof typeof ToastID];

export const useLogout = () => {
	const { logOut } = useAuthentication();
	const queryClient = useQueryClient();
	const location = useLocation();

	const createRememberedLocation = () => {
		const rememberedLocation = `${location.pathname}${location.search}${location.hash}`;
		return encodeURIComponent(rememberedLocation);
	};

	const logoutCleanup = () => {
		logOut();
		queryClient.clear();
		window.sessionStorage.clear();
	};

	return {
		logOut: ({
			rememberLocation = true,
			toastId,
		}: {
			/** if true, remembers the current location to redirect back after login */
			rememberLocation?: boolean;
			/** Determines which toast message should be shown after logout */
			toastId?: ToastID;
		} = {}) => {
			logoutCleanup();
			const searchParams = new URLSearchParams();
			if (rememberLocation) {
				searchParams.set("from", createRememberedLocation());
			}
			if (toastId) {
				searchParams.set("toastId", toastId);
			}
			const query = searchParams.toString();
			window.location.assign(query ? `/?${query}` : "/");
		},
		// only used with auto-login
		logOutWithoutNav: () => {
			logoutCleanup();
		},
	};
};
